/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";

import t from "../../../../Common/utils/translation/translator";

import MsxIcons from "../../../../Common/components/Icons/MsxIcons/MsxIcons";

const AxisSelectionFilterFiltersButton = ({
  filtersOpened,
  onClick,
  isLoadingOrFetchingGetAxesCombinations,
  cartesianFilters
}) => {
  const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);

  const countAppliedFilters = (filters) => {
    let count = 0;
    if (filters.axisFilter?.axisType && filters.axisFilter?.axisType?.length > 0) {
      count += 1;
    }
    if (filters.axisFilter?.driveType && filters.axisFilter?.driveType?.length > 0) {
      count += 1;
    }
    if (filters.axisFilter?.profileDimension && filters.axisFilter?.profileDimension?.length > 0) {
      count += 1;
    }
    if (filters.guideFilter?.guideType && filters.guideFilter?.guideType?.length > 0) {
      count += 1;
    }
    return count;
  };

  useEffect(() => {
    setAppliedFiltersCount(countAppliedFilters(cartesianFilters));
  }, [cartesianFilters]);

  return (
    <div
      className="flex items-center cursor-pointer text-center text-lg shadow rounded-full border border-gray-300 w-full py-2 hover:bg-gray-100 transition-all duration-100"
      onClick={onClick}
    >
      <div className="flex-1 flex items-center justify-center space-x-2 mr-5">
        {!isLoadingOrFetchingGetAxesCombinations && <MsxIcons name="action_filter" size="small" />}
        <span className="font-semibold text-gray-700">
          {isLoadingOrFetchingGetAxesCombinations ? t("msizer.ui.loading") : t("cartesian.ui.axis_selection.filters")}
        </span>
        {appliedFiltersCount > 0 && (
          <span className="bg-primary w-5 h-5 text-white rounded-full flex items-center justify-center text-xs font-semibold">
            {appliedFiltersCount}
          </span>
        )}
      </div>
      <MsxIcons
        name="arrow3_down"
        className={`text-gray-500 mx-5 transition-all duration-100 ${filtersOpened ? "transform rotate-180" : ""}`}
        size="small"
      />
    </div>
  );
};

export default AxisSelectionFilterFiltersButton;
